{
  "nl": {
    "inspiration_list": {
      "actions": {
        "cancel": "Cancel",
        "delete": "Verwijderen",
        "deleteMultiple": "Verwijder...",
        "delete_cancel": "Annuleren",
        "edit": "Bewerken",
        "new": "Nieuw fotoalbum",
        "save": "Opslaan",
        "submit": "Opslaan",
        "tickBoxesDeletion": "Selecteer de inspiratiealbums die je wil verwijderen."
      },
      "attributes": {
        "name": "Naam"
      },
      "info": "Waar droom jij van voor jouw nieuwe thuis? Upload foto's die jou inspireren! Je kan ze ordenen in verschillende albums: keuken, badkamer, meubels, ...",
      "labels": {
        "inspiration_list": "Inspiratiealbums",
        "inspirationlist": "Inspiratiealbum",
        "inspirations": "Inspiraties",
        "noInspirationLists": "Nog geen inspiratiealbums op dit moment",
        "noInspirations": "Nog geen inspiraties"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Creëer verschillende albums voor jouw keuken, badkamer of meubels en upload foto’s die jou inspireren.",
            "title": "Hoe wil jij jouw nieuwe woning decoreren?"
          }
        }
      },
      "validation": {
        "needTitle": "Titel is verplicht",
        "selectInspirationList": "Selecteer ten minste 1 inspiratiealbum"
      }
    }
  }
}